(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["panacea-free-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('panacea-free-shipping-progress')) {
    customElements.define(
      'panacea-free-shipping-progress',
      class PanaceaFreeShippingProgress extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold || '0', 10);
          this.currentTotal = parseInt(this.dataset.currentTotal || '0', 10);
          this.variantPrice = parseInt(this.dataset.initialVariantPrice || '0', 10);
          this.productFormId = this.dataset.productFormId;
          this.sectionId = this.dataset.sectionId;
          this.messageElement = this.querySelector('[data-message]');
          this.remainingElement = this.querySelector('[data-remaining]');
          this.fillElement = this.querySelector('[data-fill]');

          this.progressPrefix = this.dataset.progressPrefix || 'Te faltan';
          this.progressSuffix = this.dataset.progressSuffix || 'para obtener envio gratis';
          this.successMessage = this.dataset.successMessage || 'Ya tienes envio gratis';
          this.moneyFormat = this.dataset.moneyFormat || '';

          this.attachProductListeners();
          this.render();
        }

        disconnectedCallback() {
          if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
          if (this.quantityInput) this.quantityInput.removeEventListener('input', this.boundRenderFromQuantity);
          if (this.quantityInput) this.quantityInput.removeEventListener('change', this.boundRenderFromQuantity);
        }

        attachProductListeners() {
          if (!this.productFormId) return;

          const scope = this.closest('product-info') || document;
          this.quantityInput = scope.querySelector(`[form="${this.productFormId}"]`);
          this.boundRenderFromQuantity = this.updateFromQuantity.bind(this);

          if (this.quantityInput) {
            this.quantityInput.addEventListener('input', this.boundRenderFromQuantity);
            this.quantityInput.addEventListener('change', this.boundRenderFromQuantity);
          }

          if (typeof subscribe === 'function') {
            this.variantChangeUnsubscriber = subscribe('variant-change', (event) => {
              if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
              if (!event.data.variant || !event.data.variant.price) return;
              this.variantPrice = parseInt(event.data.variant.price, 10);
              this.updateFromQuantity();
            });
          }
        }

        updateFromQuantity() {
          const quantity = this.quantityInput ? parseInt(this.quantityInput.value || '1', 10) : 1;
          const normalizedQuantity = Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
          this.currentTotal = this.variantPrice * normalizedQuantity;
          this.render();
        }

        formatMoney(cents) {
          if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents, this.moneyFormat);
          }

          return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
          }).format(cents / 100);
        }

        render() {
          if (!this.threshold || !this.messageElement || !this.fillElement) return;

          const remaining = Math.max(this.threshold - this.currentTotal, 0);
          const progress = Math.min((this.currentTotal / this.threshold) * 100, 100);

          this.fillElement.style.width = `${progress}%`;

          if (remaining <= 0) {
            this.messageElement.textContent = this.successMessage;
            return;
          }

          this.messageElement.innerHTML = `${this.progressPrefix} <strong>${this.formatMoney(remaining)}</strong> ${this.progressSuffix}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
